import { useQuery } from 'react-query';
import { getWeekPortfolioList } from './helpers';

export const useWeekPortfolioList = () =>
  useQuery(['weekPortfolioList'], () => getWeekPortfolioList(), {
    suspense: true,
  });
